export enum UploadResultType {
    Success = 1,
    Error = 2,
    Interrupted = 3
}